import {SubscriptionSubjectType} from '../../../streaming/subscription-subject-type';

// TODO: Dev only
export const createDexTempSubject = <T = any>(sub: string): SubscriptionSubjectType<T> => {
    return {
        name: sub.replace('SUSCRIBE_', ''),
        // isMultiSubject: false,
        // splitSubjectOnSubscribe: false,
        operations: {
            SUBSCRIBE: sub,
            UNSUBSCRIBE: `UN${sub}`
        }
        // messagePipe?: OperatorFunction<WebSocketMessage, T>;
        // subscriptionSent$?: Subject<SubscriptionSubject>;
        // disconnected$?: Subject<void>;
        // sharedActualizeUnsubscription$?: Subject<void>;
        // subjectPipeFactory?(subject: SubscriptionSubject): OperatorFunction<T, T>;
        // deprecateSubject?(subject: SubscriptionSubject): void;
    };
};
